import React, {useEffect, useState} from 'react';

import './ReserveMng.css';
import Http from 'Utils/Axios';
import Layout from 'layouts/Default/Default';
import ReserveMngListForm from "./ReserveMngList/ReserveMngListForm";
import ReserveMngAddForm from "./ReserveMngAdd/ReserveMngAddForm";
import {fncgGetUserLoginCheck, fncgGetDbconn} from "Utils/Common/ComCom";
import {DISP_FG, PRM_ID, RESERVE_ID, SEARCH_ID} from "../../../Utils/Common/ComConst";
import {useLocation} from "react-router-dom";

let dispFlg = '0';

function ReserveMng({ match, history, location }) {
	const [user, setUser] = useState('');
	const [data, setData] = useState('');
	const [disp, setDisp] = useState('0');
	const [urlpram, setUrlPram] = useState('');
	const [dbconn, setDbConn] = useState('');
	const [start, setStart] = useState('0');
	const path = useLocation().pathname;
	const handleSetUser = userData => setUser(userData);
	const handleSetUrlPram = dat => setUrlPram(dat);
	const handleSetDbConn = dat => setDbConn(dat);
	const handleSetStart = dat => setStart(dat);

	/**
	 * 初期処理
	 */
	useEffect(() => {
		//-- 画面情報
		const dispFg = localStorage.getItem(DISP_FG);
		if(dispFg != '' && dispFg != undefined){
			dispFlg = dispFg;
		}else{
			dispFlg = '0';
		}
		let searchID = localStorage.getItem(SEARCH_ID);
		if(searchID != '' && searchID != undefined){
			searchID = JSON.parse(searchID);
			setData(searchID);
		}
		//-- 検索条件
		let reserveID = localStorage.getItem(RESERVE_ID);
		if(reserveID != '' && reserveID != undefined){
			reserveID = JSON.parse(reserveID);
			global.g_user_nm = reserveID.user_nm;
			global.g_user_kn = reserveID.user_kn;
			global.g_start_date = reserveID.start_date;
			global.g_end_date = reserveID.end_date;
			global.g_sts_reserve = reserveID.sts_reserve;
			global.g_sts_comp = reserveID.sts_comp;
			global.g_sts_cancel = reserveID.sts_cancel;
			global.g_sts_not = reserveID.sts_not;
			global.g_sts_late = reserveID.sts_late;
			global.g_search_normal_rsv = '1';
			global.g_search_instant_rsv= '1';
		}

		fncgGetDbconn({history, location, handleSetUrlPram, handleSetDbConn, handleSetStart});
	}, [])

	/**
	 * スタッフ情報取得
	 */
	useEffect(() => {
		if(start == '0') return;
		// ログインチェックを行いユーザ情報を返却する
		fncgGetUserLoginCheck({dbconn, urlpram, path, user, handleSetUser, history})
	}, [start])

	/**
	 * 登録画面
	 * @param data
	 */
	const onSubmitMoveAddDisp = data => {
		setDisp('1');
		setData(data);
		dispFlg = '1';
		localStorage.setItem(DISP_FG, '1');
		window.scrollTo(0, 0);
	}

	/**
	 * 一覧画面表示
	 * @param data
	 */
	const onSubmitMoveListDisp = data => {
		dispFlg = '0';
		setDisp('0');
		setData(data);
		localStorage.setItem(DISP_FG, '0');
		window.scrollTo(0, 0);
	}

	return (
		<>
			{(dispFlg == '0' && user != "" && user != undefined && dbconn.id != '' && dbconn.id != undefined) &&(
				<Layout headerText="予約管理(会員状況) -予約一覧-" _dbconn={dbconn} _user={user}>
					<ReserveMngListForm
						history={history}
						dbconn={dbconn}
						submitMove={onSubmitMoveAddDisp}
					/>
				</Layout >
			)}

			{(dispFlg == '1' && user != "" && user != undefined && dbconn.id != '' && dbconn.id != undefined) &&(
				<Layout headerText="予約管理(会員状況) -予約登録-" _dbconn={dbconn} _user={user}>
					<ReserveMngAddForm
						history={history}
						user={user}
						data={data}
						dbconn={dbconn}
						submitReturn={onSubmitMoveListDisp}
					/>
				</Layout>
			)}
		</>
	);

}

export default ReserveMng;